import { SCENARIO_ACTIONS } from "components/dashboard/TrainSAM/Scenarios/enum";
import { ToastContext } from "components/dashboard/common/Toast/context/ToastContextProvider";
import { ConfirmAction, Modal } from "components/ui";
import { useContext, useState } from "react";
import { apiRoute } from "services";
import API from "services/lib/api";
import { dataQueryStatus } from "utils";
import { getErrorMessage } from "utils/helper";

const { ERROR } = dataQueryStatus;

const DeleteBranchScenario = ({
    closeModal,
    showModal,
    handleSuccess,
    reference,
    type
}) => {
    const [loading, setLoading] = useState(false);
    const toastMessage = useContext(ToastContext);
    const isBranchCollection = type === SCENARIO_ACTIONS?.DETACH_SCENARIO_COLLECTION;

    const deleteScenario = async () => {
        try {
            setLoading(true);

            const url = isBranchCollection ? apiRoute.detachGuideScenairoCollection(reference?.guideFlowId, reference?.branchCollectionId) : apiRoute.deleteScenario(reference?.guideScenairoId);
            const res = isBranchCollection ? await API.post(url) : await API.delete(url);

            if (res.status === 200 || res.status === 201) {
                const { message } = res.data;
                toastMessage(message);
                handleSuccess?.();
            }
        } catch (err) {
            setLoading(false);
            const message = getErrorMessage(err);
            toastMessage(message, ERROR);
        }
    };

    return (
        <Modal show={showModal} close={closeModal}>
            <ConfirmAction
                title={`Are you sure you want to ${isBranchCollection ? "Remove this Collection" : "Delete this scenario"}`}
                loading={loading}
                close={closeModal}
                handleYesClick={deleteScenario}
            />
        </Modal>
    );
};

export default DeleteBranchScenario;
